import * as generic from '../actions/generic';
import * as endPoints from '../actions/endpoints';
import config from "../config";

const createLead = body => generic.getApiMiddlewareJson(
  createFullPath(endPoints.CREATE_LEAD),
  generic.POST,
  generic.REQUEST_ADD_LEAD,
  generic.SUCCESS_ADD_LEAD,
  generic.FAILED_ADD_LEAD,
  body,
);

export const setDefaultLanguage = (defaultLanguage) => {
  return {
    type: generic.SET_SELECTED_LANGUAGE,
    defaultLanguage
  }
}

export const getPincodeDetails = pinCode => generic.getApiMiddlewareJson(
  createFullPath(endPoints.GET_PINCODE_DETAILS.replace(':pin_code',pinCode)),
  generic.GET,
  generic.REQUEST_PINCODE_DETAILS,
  generic.SUCCESS_PINCODE_DETAILS,
  generic.FAILED_PINCODE_DETAILS
);

export const createSubscriber = body => generic.getApiMiddlewareJson(
    createFullPath(endPoints.SUBSCRIBER),
    generic.POST,
    generic.REQUEST_SUBSCRIBER,
    generic.SUCCESS_SUBSCRIBER,
    generic.FAILED_SUBSCRIBER,
    body,
);

export function createFullPath (path) {
  const fullPath = `${config.site_api}${path}`
  return fullPath
}

export const partnerEnquiryForm = body => generic.getApiMiddlewareJson(
  createFullPath(endPoints.PARTNER_ENQUIRY_FORM),
  generic.POST,
  generic.REQUEST_PARTNER_ENQUIRY_FORM,
  generic.SUCCESS_PARTNER_ENQUIRY_FORM,
  generic.FAILED_PARTNER_ENQUIRY_FORM,
  body,
);

export default createLead;



// WEBPACK FOOTER //
// ./src/actions/lead.js